import React, { Component } from 'react'
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import moment from 'moment'

import LandingPage from './landing'
import LandingPageCA from './landing_ca'
import queryString from 'query-string'
import ErrorPage from '../error/error'
import FetchWrapper from '../../utils/fetch_wrapper'

import config from './../../utils/config'

class Landing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: null,
      loading: true
    }
    document.title = "Newtopia"
  }

  async componentDidMount() {
    const response = await this.getLandingConfig()
    if (!response) {
      this.props.error()
    } else {
      this.setState({ loading: false })
    }
  }

  _nextPage(param) {
    return this.props.next(param)
  }

  errorPage() {
    return (
      <ErrorPage />
    )
  }

  extendRoute(R, props) {
    if (!this.state.data) return null
    return (
      <R 
        {...props}
        registrationOpenDate = {this.state.data.Registration_Open_Date ? moment(this.state.data.Registration_Open_Date) : undefined}
        registrationCloseDate = {this.state.data.Registration_Close_Date ? moment(this.state.data.Registration_Close_Date) : undefined}
        registrationClosedText = {this.state.data.Registration_Closed_Text}
        comingSoonText = {this.state.data.Coming_Soon_Text}
        pageType = {props.match.params['0']}
        client = {this.state.data.Account_Name}
        clientText = {this.state.data.Client_Custom_Text}
        clientImg = {this.state.data.Logo_Image}
        clientImgText = {this.state.data.Logo_Image_Text}
        module1ProgramText = {this.state.data.Module1_Program_Text}
        next = {this._nextPage.bind(this, props.match.params['0'])}
        registrationPagesLogoImage={this.props.registrationPagesLogoImage}
      />
    )
  }

  async getLandingConfig() {
    const code = queryString.parse(this.props.location.search)
    try {
      let response = await FetchWrapper.fetch(config.endpoint_get_landing_configuration + '&regCode=' + code.regCode, {
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
      })

      const { data } = response
      this.setState({ data })
      return true
    }
    catch(e) {
      return false
    }
  }

  render() {
    if (this.state.loading) return <div></div>
    return (
      <div id="landing">
        <Router basename={this.props.match.path}>
          <Switch>
            <Route render={props => this.extendRoute(config.country == 'US' ? LandingPage : LandingPageCA, props)} />
          </Switch>
        </Router>
      </div>
    )
  }
}

export default Landing
